import { render, staticRenderFns } from "./M_robot.vue?vue&type=template&id=f36c507a&scoped=true&"
import script from "./M_robot.vue?vue&type=script&lang=js&"
export * from "./M_robot.vue?vue&type=script&lang=js&"
import style0 from "./M_robot.vue?vue&type=style&index=0&id=f36c507a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36c507a",
  null
  
)

export default component.exports